import { render, staticRenderFns } from "./Level.vue?vue&type=template&id=c85f9170&scoped=true&lang=html"
import script from "./Level.vue?vue&type=script&lang=js"
export * from "./Level.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85f9170",
  null
  
)

export default component.exports